import { TFunction } from 'i18next';
import { ClientNetworkError } from '~client/error/client-network-error';
import { ClientRequestError } from '~client/error/client-request-error';
import { ClientServerError } from '~client/error/client-server-error';
import { ClientTimeoutError } from '~client/error/client-timeout-error';

export const getErrorMessage = (t: TFunction, error: Error): string | undefined => {
  if (error == undefined) {
    return undefined;
  }

  if (error instanceof ClientRequestError) {
    return (error.response && error.response.message) || t('error.requestInvalid');
  }

  if (error instanceof ClientServerError) {
    return (error.response && error.response.message) || t('error.serverError');
  }

  if (error instanceof ClientNetworkError) {
    return t('error.serverUnreachable');
  }

  if (error instanceof ClientTimeoutError) {
    return t('error.serverTimeout');
  }

  return t('error.unknownError');
};



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/i18n/error-mapper.ts